<div>
  <appMetadataWidget [data]="data"></appMetadataWidget>
  <app-metadata-field [data]="data"></app-metadata-field>
  <div id="metadata-field">
    <div class="metadata-block">
      <label class="metadata-key" for="label" title="{{ data.id }}">Field Type:</label>
      <div class="metadata-properties">
        <select class="metadata-input-field" [(ngModel)]="data.type" (ngModelChange)="onTypeSelected($event)">
          <!--  -->
          <option value="datepicker" selected>Datepicker</option>
          <option value="time">Time</option>
          <option value="date">Date</option>
          <option value="textarea">Textarea</option>
          <option value="radio">Radio</option>
          <option value="checkbox">Checkbox</option>
          <option value="input" selected>Input</option>
          <option value="select">Select</option>
          <option value="multi-select">MultiSelect</option>
          <option value="paragraph">Paragraph</option>
          <option value="toggle">Toggle</option>
          <option value="slider">Slider</option>        
        </select>
      </div>
    </div>
    <div class="metadata-block">      
      <label class="metadata-key" for="label" title="{{ data.id }}">Label:</label>
      <div class="metadata-input-block">
        <input class="metadata-input-field" id="label" type="text" placeholder="{{ data.label }}"
          [(ngModel)]="data.label" />
      </div>
    </div>
    <div class="metadata-block">
      <label class="metadata-key" for="desc">Description:</label>
      <div class="metadata-input-block">
        <input class="metadata-input-field" id="desc" type="text" [(ngModel)]="data.description" />
      </div>
    </div>
    <div class="metadata-block">
      <label class="metadata-key" for="reqCheck">Required:</label>
      <div>
        <input class="metadata-input-field" id="reqCheck" type="checkbox" [(ngModel)]="data.required" />
      </div>
    </div>
    <!-- Comments -->    
    <div class="metadata-block" fxLayout="row wrap">
      <div class="metadata-title">Comment</div>         
    </div>    
    <div class="metadata-block" fxLayout="row wrap">         
      <div class="metadata-properties">
        <div class="metadata-key" for="commentKey" title="{{ data.id }}">Key</div>
        <div class="metadata-input-block">
          <mat-icon matPrefix class="metadata-input-icon">mode_edit</mat-icon>
          <input tabindex="1" fxFlex="flex-grow" class="metadata-input-field" id="commentKey" type="text"
            placeholder="{{ data.commentKey }}" [(ngModel)]="data.commentKey" />
        </div>        
      </div>
    </div>    
  </div>
</div>